import { render, staticRenderFns } from "./BackgroundGraphicCenter.vue?vue&type=template&id=67e5263f&"
import script from "./BackgroundGraphicCenter.vue?vue&type=script&lang=js&"
export * from "./BackgroundGraphicCenter.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundGraphicCenter.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports